/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/ErrorOutline';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const ErrorOutlineIcon = withMuiAdapter(Base, 'ErrorOutline');
